import { handleActions } from 'redux-actions';
import { types } from '../constants';
import {} from '@material-ui/icons';

const INITIAL_STATE = {
  hazardsByBranch: {
    items: [],
    itemsCopy: [],
    isLoading: false,
    errorMessage: '',
    searchTerm: ''
  },
  hazardsByCompany: {
    items: [],
    itemsCopy: [],
    isLoading: false,
    errorMessage: ''
  },
  deleteHazard: {
    openDialog: false,
    hazard: null,
    isSaving: false,
    errorMessage: false
  },
  hazardStatusFilter: {
    filter: 0,
    items: [
      { id: 0, value: 'All Hazards' },
      { id: 1, value: 'Raised' },
      { id: 2, value: 'Managed' },
      { id: 3, value: 'Removed' }
    ]
  },
  hazardDescriptionFilter: {
    filter: 0,
    items: [
      { id: 0, value: 'Description A-Z' },
      { id: 1, value: 'Description Z-A' }
    ]
  }
};

const filterHazardBasedOnStatusType = (allHazards, statusId) => {
  let filteredHazards;
  if (statusId === 0) {
    filteredHazards = allHazards;
  } else if (statusId === 1) {
    //Raised
    filteredHazards = allHazards.filter((g) => g.status === 1);
  } else if (statusId === 2) {
    //Managed
    filteredHazards = allHazards.filter((g) => g.status === 2);
  } else if (statusId === 3) {
    //Removed
    filteredHazards = allHazards.filter((g) => g.status === 3);
  }

  return filteredHazards;
};

const filterHazardBasedOnDescriptionSortType = (allHazards, sortId) => {
  let filteredHazards;
  if (sortId === 0) {
    filteredHazards = allHazards.sort((a, b) =>
      a.description.toLowerCase().localeCompare(b.description.toLowerCase())
    );
  } else if (sortId === 1) {
    filteredHazards = allHazards.sort((a, b) =>
      b.description.toLowerCase().localeCompare(a.description.toLowerCase())
    );
  }
  return filteredHazards;
};

const changeSelectedHazardDescriptionSortTypeFilter = (state, { sortId }) => {
  let filteredHazards = filterHazardBasedOnDescriptionSortType(
    state.hazardsByBranch.items,
    sortId
  );

  return {
    ...state,
    hazardDescriptionFilter: {
      ...state.hazardDescriptionFilter,
      filter: sortId
    },
    hazardsByBranch: {
      ...state.hazardsByBranch,
      items: filteredHazards
    }
  };
};

const changeSelectedHazardStatusTypeFilter = (state, { statusId }) => {
  let filteredHazards = filterHazardBasedOnStatusType(
    state.hazardsByBranch.itemsCopy,
    statusId
  );

  let sortedFilteredHazards = filterHazardBasedOnDescriptionSortType(
    filteredHazards,
    state.hazardDescriptionFilter.filter
  );
  return {
    ...state,
    hazardsByBranch: {
      ...state.hazardsByBranch,
      items: sortedFilteredHazards
    },
    hazardStatusFilter: {
      ...state.hazardStatusFilter,
      filter: statusId
    }
  };
};

const startDeleteHazard = (state) => {
  return {
    ...state,
    deleteHazard: {
      ...state.deleteHazard,
      isSaving: true
    }
  };
};
const deleteHazardSuccess = (state, { hazardId }) => {
  var hazardsByBranch_Copy = state.hazardsByBranch.itemsCopy;
  var filteredHazards_Copy = hazardsByBranch_Copy.filter(
    (hazard) => hazard.id !== hazardId
  );

  var hazardsByBranch_Main = state.hazardsByBranch.items;
  var filteredHazards_Main = hazardsByBranch_Main.filter(
    (hazard) => hazard.id !== hazardId
  );

  return {
    ...state,
    deleteHazard: {
      ...state.deleteHazard
    },
    hazardsByBranch: {
      ...state.hazardsByBranch,
      items: filteredHazards_Main,
      itemsCopy: filteredHazards_Copy
    }
  };
};
const deleteHazardFailure = (state, { errorMessage }) => {
  return {
    ...state,
    deleteHazard: {
      ...state.deleteHazard,
      errorMessage
    }
  };
};
const deleteHazardFinished = (state) => {
  return {
    ...state,
    deleteHazard: {
      ...state.deleteHazard,
      isSaving: false
    }
  };
};

const startFetchAllHazardsForBranch = (state) => {
  return {
    ...state,
    hazardsByBranch: {
      ...state.hazardsByBranch,
      isLoading: true
    }
  };
};

const fetchAllHazardsForBranchSuccess = (state, { hazards }) => {
  return {
    ...state,
    hazardsByBranch: {
      ...state.hazardsByBranch,
      items: hazards,
      itemsCopy: hazards
    }
  };
};

const clearHazardFilters = (state) => {
  return {
    ...state,
    hazardStatusFilter: {
      ...state.hazardStatusFilter,
      filter: 0
    },
    hazardDescriptionFilter: {
      ...state.hazardDescriptionFilter,
      filter: 0
    }
  };
};

const fetchAllHazardsForBranchFailure = (state, { errorMessage }) => {
  return {
    ...state,
    hazardsByBranch: {
      ...state.hazardsByBranch,
      errorMessage
    }
  };
};

const fetchAllHazardsForBranchFinished = (state) => {
  return {
    ...state,
    hazardsByBranch: {
      ...state.hazardsByBranch,
      isLoading: false
    }
  };
};

const changeSearchTermAllHazards = (state, { searchTerm }) => {
  let hazards = [...state.hazardsByBranch.itemsCopy];

  let filteredHazards = hazards.filter(
    (e) => e.description && e.description.toLowerCase().includes(searchTerm)
  );

  filteredHazards = filterHazardBasedOnStatusType(
    filteredHazards,
    state.hazardStatusFilter.filter
  );

  filteredHazards = filterHazardBasedOnDescriptionSortType(
    filteredHazards,
    state.hazardDescriptionFilter.filter
  );

  return {
    ...state,
    hazardsByBranch: {
      ...state.hazardsByBranch,
      searchTerm,
      items: filteredHazards
    }
  };
};

const submitHazardSuccess = (state, { submittedHazard }) => {
  let hazards = [...state.hazardsByBranch.itemsCopy];
  let updatedHazardIndex = hazards.findIndex(
    (a) => a.id === submittedHazard.id
  );

  //Means updated
  if (updatedHazardIndex !== -1) {
    hazards[updatedHazardIndex] = submittedHazard;
  } else {
    hazards = [...hazards, submittedHazard];
  }

  let filteredHazards = filterHazardBasedOnStatusType(
    hazards,
    state.hazardStatusFilter.filter
  );

  filteredHazards = filterHazardBasedOnDescriptionSortType(
    filteredHazards,
    state.hazardDescriptionFilter.filter
  );

  return {
    ...state,
    hazardsByBranch: {
      ...state.hazardssByBranch,
      items: filteredHazards,
      itemsCopy: hazards
    }
  };
};

const openDeleteHazardDialog = (state, { open, hazard }) => {
  return {
    ...state,
    deleteHazard: {
      ...state.deleteHazard,
      openDialog: open,
      hazard: open === true ? hazard : null
    }
  };
};

const startFetchAllHazardsForCompany = (state) => {
  return {
    ...state,
    hazardsByCompany: {
      ...state.hazardsByCompany,
      isLoading: true
    }
  };
};

const fetchAllHazardsForCompanySuccess = (state, { hazards }) => {
  return {
    ...state,
    hazardsByCompany: {
      ...state.hazardsByCompany,
      items: hazards,
      itemsCopy: hazards
    }
  };
};

const fetchAllHazardsForCompanyFailure = (state, { errorMessage }) => {
  return {
    ...state,
    hazardsByCompany: {
      ...state.hazardsByCompany,
      errorMessage
    }
  };
};

const fetchAllHazardsForCompanyFinished = (state) => {
  return {
    ...state,
    hazardsByCompany: {
      ...state.hazardsByCompany,
      isLoading: false
    }
  };
};

//Handles the incoming actions.
export default handleActions(
  {
    [types.CLEAR_HAZARD_FILTERS]: clearHazardFilters,
    [types.CHANGE_SELECTED_HAZARD_STATUS_FILTER]: changeSelectedHazardStatusTypeFilter,

    [types.CHANGE_SELECTED_HAZARD_DESCRIPTION_FILTER]: changeSelectedHazardDescriptionSortTypeFilter,

    [types.START_FETCH_ALL_HAZARDS_FOR_BRANCH]: startFetchAllHazardsForBranch,
    [types.FETCH_ALL_HAZARDS_FOR_BRANCH_SUCCESS]: fetchAllHazardsForBranchSuccess,
    [types.FETCH_ALL_HAZARDS_FOR_BRANCH_FAILURE]: fetchAllHazardsForBranchFailure,
    [types.FETCH_ALL_HAZARDS_FOR_BRANCH_FINISHED]: fetchAllHazardsForBranchFinished,

    [types.START_FETCH_ALL_HAZARDS_FOR_COMPANY]: startFetchAllHazardsForCompany,
    [types.FETCH_ALL_HAZARDS_FOR_COMPANY_SUCCESS]: fetchAllHazardsForCompanySuccess,
    [types.FETCH_ALL_HAZARDS_FOR_COMPANY_FAILURE]: fetchAllHazardsForCompanyFailure,
    [types.FETCH_ALL_HAZARDS_FOR_COMPANY_FINISHED]: fetchAllHazardsForCompanyFinished,

    [types.CHANGE_SEARCH_TERM_ALL_HAZARDS]: changeSearchTermAllHazards,

    [types.SUBMIT_HAZARD_SUCCESS]: submitHazardSuccess,

    [types.OPEN_DELETE_HAZARD_DIALOG]: openDeleteHazardDialog,

    [types.START_DELETE_HAZARD]: startDeleteHazard,
    [types.DELETE_HAZARD_SUCCESS]: deleteHazardSuccess,
    [types.DELETE_HAZARD_FAILURE]: deleteHazardFailure,
    [types.DELETE_HAZARD_FINISHED]: deleteHazardFinished
  },
  INITIAL_STATE
);
